<template>
  <div>
    <el-table :data="urllist" style="width: 100%" height="630">
      <el-table-column label="id">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column label="lineUrl">
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper">
            <span>{{ scope.row.lineUrl }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="zh">
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper">
            <span>{{ scope.row.zh }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="en">
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper">
            <span>{{ scope.row.en }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="测速请求地址" prop="checkInterface" />
      <el-table-column label="状态">
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper">
            <el-switch
              active-color="#13ce66"
              @change="handleCodeStatusChange(scope.row, $event)"
              :value="scope.row.status ? true : false"
            ></el-switch>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            circle
            icon="el-icon-edit"
            @click="handleEdit(scope.$index, scope.row)"
          ></el-button>
          <el-button
            size="small"
            type="danger"
            circle
            icon="el-icon-delete"
            @click="handleDelete(scope.$index, scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="修改节点配置"
      width="800px"
      :visible.sync="dialogVisibleChange"
      @close="closeDialog"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="链接zh" prop="zh">
          <el-input
            v-model="ruleForm.zh"
            placeholder="请输入链接名称(中文)"
          ></el-input>
        </el-form-item>
        <el-form-item label="链接en" prop="en">
          <el-input
            v-model="ruleForm.en"
            placeholder="请输入链接名称(英文)"
          ></el-input>
        </el-form-item>
        <el-form-item label="链接地址" prop="lineUrl">
          <el-input
            v-model="ruleForm.lineUrl"
            placeholder="请输入链接地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="测速请求地址" prop="checkInterface">
          <el-input
            v-model.trim="ruleForm.checkInterface"
            placeholder="请输入测速请求地址 如 https://www.xxx.com/login"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-tooltip
            class="item"
            effect="dark"
            content="绿色为启用，红色则为未启用"
            placement="right"
          >
            <el-switch
              v-model="ruleForm.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
            ></el-switch>
          </el-tooltip>
        </el-form-item>

        <el-form-item label-width="300px">
          <el-button type="primary" @click="updateUrL('ruleForm')"
            >确定修改</el-button
          >
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import { ValidateLineUrl } from "../../validate";
export default {
  data() {
    return {
      dialogVisibleChange: false,
      result: true,
      ruleForm: {},
      upperList: [],
      rules: {
        zh: [
          {
            required: true,
            trigger: "blur",
          },
          { message: "不能为空", trigger: "blur" },
        ],
        en: [
          { required: true, trigger: "blur" },
          { message: "不能为空", trigger: "blur" },
        ],
        checkInterface: [
          { required: true, trigger: "blur" },
          { message: "测速请求地址不能为空", trigger: "blur" },
        ],
        lineUrl: [
          {
            required: true,
            validator: ValidateLineUrl,
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.getDataList();
  },
  computed: {
    ...mapState("nodeConfigStore", ["codelist", "urllist"]),
    ...mapGetters("nodeConfigStore", ["filterList"]),
    list() {
      return this.filterList.map((item) => item.locale.toUpperCase());
    },
  },
  methods: {
    ...mapActions("nodeConfigStore", [
      "getlist",
      "delOne",
      "updateOne",
      "getUrlList",
    ]),
    async getDataList() {
      this.getUrlList({ page: 1, size: 10 });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    handleEdit(index, row) {
      this.dialogVisibleChange = true;
      this.ruleForm = { ...this.ruleForm, ...row, status: Boolean(row.status) };
    },
    handleDelete(index, row) {
      const id = row.id;
      this.$confirm("确定要删除该链接地址吗？", "提示", {
        type: "warning",
      }).then(async () => {
        const res = await this.delOne(id);
        if (res.code == 0) {
          this.$message.success("操作成功");
          this.getDataList();
        } else {
          this.$message.error("操作失败！请重试");
        }
      });
    },

    handleCodeStatusChange(row, status) {
      const message = status
        ? "确认要开启当前Url状态吗？"
        : "确认要关当前Url？关闭该Url，相应的选项也将关闭。";

      this.$confirm(message, "提示", { type: "warning" }).then(async () => {
        if (row.status === 0) {
          row.status = 1;

          const res = await this.updateOne(row);

          if (res.data == 1) {
            this.$message.success("操作成功");
          }
        } else if (row.status === 1) {
          row.status = 0;

          const res = await this.updateOne(row);
          if (res.data == 1) {
            this.$message.success("操作成功");
          }
        }
      });
    },
    updateUrL(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.ruleForm.status = Number(this.ruleForm.status);

          const res = await this.updateOne(this.ruleForm);
          if (res.code == 0) {
            this.$message.success("操作成功");
            this.dialogVisibleChange = false;
            this.getDataList();
            this.result = true;
          }
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    closeDialog() {},
  },
};
</script>

<style lang="less" scoped></style>
